import React, { useEffect } from 'react'
import { ApplicationPaths, QueryParameterNames } from './ApiAuthorizationConstants'
import { useAuth } from '../../context/AuthContext'

// Guard component for React Router v7.
// Used as: <Route path="..." element={<AuthorizeRoute component={X} {...props} />} />
// Also used as a standalone render (e.g. Navbar) outside <Routes> — renders unconditionally
// once auth is initialized and authenticated.
export default function AuthorizeRoute({ component: Component, ...rest }) {
    const { isInitialized, isAuthenticated } = useAuth()

    const pathname = window.location.pathname
    const safeReturn = pathname.toLowerCase().startsWith(ApplicationPaths.Login.toLowerCase())
        ? '/'
        : pathname
    const loginUrl = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(safeReturn)}`

    useEffect(() => {
        if (isInitialized && !isAuthenticated) {
            window.location.replace(loginUrl)
        }
    }, [isInitialized, isAuthenticated, loginUrl])

    if (!isInitialized) {
        return <div></div>
    }

    if (!isAuthenticated) {
        return null
    }

    return <Component {...rest} />
}
